/**
 * Legacy slice defaults
 */

import type { SimpleSliceContent } from "@prismicio/types-internal/lib/content"

export const defaultImageContentWidget: SimpleSliceContent = {
  __TYPE__: "ImageContent",
  edit: {
    background: "",
    crop: {
      x: 0,
      y: 0,
    },
    zoom: 0,
  },
  height: 0,
  width: 0,
  origin: {
    height: 0,
    width: 0,
    id: "",
    url: "",
  },
  url: "",
}
